/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMeProfileResponseDto } from '../../models/backend-me-profile-response-dto';

export interface MeMeGet$Params {}

export function meMeGet(
  http: HttpClient,
  rootUrl: string,
  params?: MeMeGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendMeProfileResponseDto>> {
  const rb = new RequestBuilder(rootUrl, meMeGet.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendMeProfileResponseDto>;
    }),
  );
}

meMeGet.PATH = '/me';
